import React, { useState, ChangeEvent } from 'react';
import { InputArea, Loader, ContainerInput } from './styles';
//components
import Input from 'components/Input';
import { Visibility } from 'components/Visibility';
//interfaces
import { IInputYesOrNo } from './interface';
//assets
import cancelIcon from "img/cancel-icon.svg";
import confirmIcon from "img/confirm-icon.svg";
import grayCancelIcon from "img/gray-cancel-icon.svg";
import grayConfirmIcon from "img/gray-confirm-icon.svg";
//utils
import { currencyPositive } from 'pages/Quotes/utils/patterns';

export const InputYesOrNo: React.FC<IInputYesOrNo> = (props) => {
  const { onClickfunction, visible, disabled } = props;

  const [onFocus, setOnFocus] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const confirm = onFocus ? confirmIcon : grayConfirmIcon;
  const cancel = onFocus ? cancelIcon : grayCancelIcon;

  const clearSearch = () => {
    setValue('');
  };

  const confirmFunction = () => {
    onClickfunction(value);
    setValue('');
  };

  return (
    <InputArea focus={onFocus}>
      <ContainerInput>
        <Visibility visible={visible}>
          <Loader />
        </Visibility>

        <Input
          type='text'
          value={value}
          placeholder={'-'}
          disabled={disabled}
          onFocus={() => setOnFocus(true)}
          onBlur={() => setOnFocus(false)}
          pattern={currencyPositive}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
        />
      </ContainerInput>

      <img src={confirm} className='inputBtn' onClick={() => confirmFunction()} />
      <img src={cancel} className='inputBtn' onClick={() => clearSearch()} />
    </InputArea>
  );
};
